import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemButton from '@mui/material/ListItemButton';
import Checkbox from '@mui/material/Checkbox';
import Divider from "@material-ui/core/Divider";
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import { getThemeProps } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SelectedListItem(props) {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(props.selectedEnv?.map(s => s.id));
  
  const handleListItemClick = (event, index, listitem) => {
    let items = props.selectedEnv 
    let item  = items.filter(i => i?.id == listitem?.id)
    if(item.length) {
      items = items.filter(i => i.id != listitem.id)
    } else {
      items.push(listitem)
    }
    
    setSelectedIndex(items.map(i => i.id))
    props.setSelectedEnv(items);
  }

  React.useEffect(() => {}, [
    props.selectedEnv, selectedIndex
  ])

  return (
    <div className={classes.root}>
      <List aria-label="secondary mailbox folder">
        {props.configs &&
          props.configs.map((listitem, index) => {
            return (
              <ListItem
                key={listitem.alias + listitem.host}
                button
                selected={selectedIndex?.includes(listitem.id)}
                onClick={(event) => handleListItemClick(event, index, listitem)}
              >
                {/* <ListItemText
                  primary={listitem.alias}
                  secondary={listitem.host}
                /> */}
                {/* <ListItemButton role={undefined} dense> */}
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={selectedIndex?.includes(listitem.id)}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText 
                    primary={listitem.alias}
                    secondary={listitem.host}
                  />
                {/* </ListItemButton> */}
              </ListItem>
            );
          })}
      </List>
    </div>
  );
}
